import { Component, OnInit } from '@angular/core';
import { getClaimKey } from '../../../../../functions/get-claim-key';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { Attributes } from '../../../../../models/api/view/claim/details/attributes/attributes';
import { DisabilityDetail } from '../../../../../models/api/view/claim/details/disability/disability-detail';
import { Subowner } from '../../../../../models/api/view/claim/details/disability/subowner';
import { BaseComponent } from '../../../../base/base.component';
import { PageHeaderComponent } from '../../../../core/labels/page-header.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { TogglePanelComponent } from '../../../../core/panels/toggle-panel.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { TableComponent } from '../../../../core/table/table.component';
import { PolicyAttributesComponent } from '../../../policy-details/policy-attributes.component';
import { RelatedClaimsComponent } from '../../../related-claims/related-claims.component';
import { StatusHistoryComponent } from '../../../status-history/status-history.component';

@Component({
  selector: 'app-disability',
  imports: [
    PageHeaderComponent,
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    TogglePanelComponent,
    TableComponent,
    ColumnComponent,
    RelatedClaimsComponent,
    StatusHistoryComponent,
    PolicyAttributesComponent,
  ],
  template: `
    <app-page-header
      [label]="claimRow.coverageCode === 'AC' ? 'Accommodations' : 'Disability'"
    />
    @if (claimRow.coverageCode !== 'AC') {
      <div class="tw-flex tw-gap-8">
        <app-detail-panel [dataSource]="disability" class="tw-basis-1/3">
          <app-detail-item label="Disability Due To" name="disabilityDueTo" />
          <app-detail-item
            label="Hospitalized"
            name="hospitalFlag"
            format="b"
          />
          <app-detail-item label="Surgery" name="surgeryFlag" format="b" />
          <app-detail-item
            label="Medical Due Date"
            name="dateMedicalDue"
            format="d"
          />
          <app-detail-item
            label="Initial date of disability"
            name="initialDateOfDisability"
            format="d"
          />
        </app-detail-panel>
        <app-detail-panel [dataSource]="disability" class="tw-basis-1/3">
          @if (this.restDsLaAuth && this.custDispAuth) {
            <app-detail-item label="Current Diagnosis" name="intakeDiagnosis" />
          }
          <app-detail-item
            label="Date Hospitalized"
            name="dateHospitalized"
            format="d"
          />
          <app-detail-item label="Surgery Type" name="surgeryType" />
          <app-detail-item
            label="Next Doctor Visit"
            name="dateNextDoctorVisit"
            format="d"
          />
          <app-detail-item
            label="Most recent date of disability"
            name="mostRecentDateOfDisability"
            format="d"
          />
        </app-detail-panel>
        <app-detail-panel [dataSource]="disability" class="tw-basis-1/3">
          <app-detail-item label="Work Related" name="workRelated" format="b" />
          <app-detail-item
            label="Date Discharged"
            name="dateDischarged"
            format="d"
          />
          <app-detail-item
            label="Date of Surgery"
            name="dateOfSurgery"
            format="d"
          />
          @if (disability?.pregnancyDueDate) {
            <app-detail-item
              label="Pregnancy Due Date"
              name="pregnancyDueDate"
              format="d"
            />
          }
        </app-detail-panel>
      </div>
    }
    <div class="tw-flex tw-gap-8 tw-pb-8 tw-pt-6">
      @if (claimRow.coverageCode === 'AC') {
        <div class="tw-basis-1/3">
          <app-card label="release of info">
            <app-detail-panel [dataSource]="disability">
              <app-detail-item
                label="Date Sent"
                name="dateROISent"
                format="d"
              />
              <app-detail-item
                label="Date Received"
                name="dateROIReceived"
                format="d"
              />
              <app-detail-item
                label="Electronic"
                name="electronic"
                format="b"
              />
              <app-detail-item
                label="Electronic Received"
                name="electronicReceived"
              />
              <app-detail-item
                label="Response"
                name="electronicResponseReceived"
                format="d"
              />
            </app-detail-panel>
          </app-card>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="disability" class="tw-basis-1/3">
            <app-detail-item
              label="Hospitalized"
              name="hospitalFlag"
              format="b"
            />
            <app-detail-item
              label="Medical Due Date"
              name="dateMedicalDue"
              format="d"
            />
            @if (this.restDsLaAuth && this.custDispAuth) {
              <app-detail-item
                label="Current Diagnosis"
                name="intakeDiagnosis"
              />
            }
            <app-detail-item
              label="Date Hospitalized"
              name="dateHospitalized"
              format="d"
            />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="disability" class="tw-basis-1/3">
            <app-detail-item
              label="Work Related"
              name="workRelated"
              format="b"
            />
            <app-detail-item
              label="Next Doctor Visit"
              name="dateNextDoctorVisit"
              format="d"
            />
            <app-detail-item
              label="Pregnancy Due Date"
              name="pregnancyDueDate"
              format="d"
            />
          </app-detail-panel>
        </div>
      }
      @if (claimRow.coverageCode !== 'AC') {
        <div class="tw-basis-1/3">
          <app-card label="release of info">
            <app-detail-panel [dataSource]="disability">
              <app-detail-item
                label="Date Sent"
                name="dateROISent"
                format="d"
              />
              <app-detail-item
                label="Date Received"
                name="dateROIReceived"
                format="d"
              />
              <app-detail-item
                label="Electronic"
                name="electronic"
                format="b"
              />
              <app-detail-item
                label="Electronic Received"
                name="electronicReceived"
              />
              <app-detail-item
                label="Response"
                name="electronicResponseReceived"
                format="d"
              />
            </app-detail-panel>
          </app-card>
        </div>
        <div class="tw-basis-1/3">
          <div class="tw-flex tw-flex-col tw-gap-8">
            <app-card label="overpay agreement">
              <app-detail-panel [dataSource]="disability">
                <app-detail-item
                  label="Date Sent"
                  name="dateOASent"
                  format="d"
                />
                <app-detail-item
                  label="Date Received"
                  name="dateOAReceived"
                  format="d"
                />
              </app-detail-panel>
            </app-card>

            <app-card label="Change in definition (LTD only)">
              <app-detail-panel [dataSource]="disability">
                <app-detail-item label="Date" name="dateChangeDef" format="d" />
                <app-detail-item
                  label="Completion Date"
                  name="dateChangeDefCompleted"
                  format="d"
                />
              </app-detail-panel>
            </app-card>
          </div>
        </div>

        <div class="tw-basis-1/3 tw-flex tw-flex-col tw-gap-8">
          <app-card label="Date received">
            <app-detail-panel [dataSource]="disability">
              <app-detail-item
                label="Employee Statement"
                name="dateEmployeeStatementReceived"
                format="d"
              />
              <app-detail-item
                label="Employer Statement"
                name="dateEmployerStatementReceived"
                format="d"
              />
              <app-detail-item
                label="First Medical"
                name="dateFirstMedical"
                format="d"
              />
              <app-detail-item
                label="Latest Medical"
                name="dateLatestMedical"
                format="d"
              />
            </app-detail-panel>
          </app-card>

          <app-card label="Other">
            <app-detail-panel [dataSource]="disability">
              <app-detail-item
                label="Weekly State Award Amt"
                name="weeklyStateAwardAmount"
                format="c"
              />
              <app-detail-item
                label="Alternate Benefit"
                name="alternateBenefitAmount"
                format="c"
              />
              <app-detail-item
                label="Alt. Benefit Frequency"
                name="alternateBenefitFrequency"
              />
              <app-detail-item
                label="Maximum Total Benefit"
                name="maximumTotalBenefit"
                format="c"
              />
            </app-detail-panel>
          </app-card>
        </div>
      }
    </div>

    <app-toggle-panel #togglePanel>
      @if (claimRow.coverageCode !== 'AC') {
        @if (this.subOwnerAuth) {
          <div class="tw-flex tw-gap-4 tw-pb-4">
            @if (subowner.length > 0) {
              <app-card
                label="sub-owners"
                class="tw-grow"
                [expanded]="togglePanel.expandAll.value"
                [showExpand]="true"
              >
                <app-table
                  [dataSource]="subowner"
                  [pageSize]="10"
                  [scrollable]="false"
                  [showFilter]="false"
                  recordLabel="sub-owner"
                  [globalFilterFields]="[
                    'subownerType',
                    'fullName',
                    'dateCreated',
                    'dateExpire',
                    'phone',
                    'email',
                  ]"
                >
                  <app-column name="subownerType" label="Type" />
                  <app-column name="lastName" label="Name">
                    <ng-template let-data>
                      {{ data.firstName }} {{ data.lastName }}
                    </ng-template>
                  </app-column>
                  <app-column name="dateCreated" label="Begin" format="d" />
                  <app-column name="dateExpire" label="End" format="d" />
                  <app-column name="phone" label="Phone" format="p" />
                  <app-column name="email" label="Email" />
                </app-table>
              </app-card>
            }
          </div>
        }
      }
      @if (this.detailsAuth) {
        <div class="tw-flex tw-gap-4 tw-pb-4">
          <app-card
            label="Related claims"
            [expanded]="togglePanel.expandAll.value"
            [showExpand]="true"
            class="tw-grow"
          >
            <app-related-claims />
          </app-card>
        </div>
      }
      @if (this.claimStatusAuth) {
        <div class="tw-flex tw-gap-4 tw-pb-4">
          <app-card
            label="Status History"
            [expanded]="togglePanel.expandAll.value"
            [showExpand]="true"
            class="tw-grow"
          >
            <app-status-history />
          </app-card>
        </div>
      }
      @if (this.claimAttributesAuth && claimRow.coverageCode !== 'AC') {
        <div class="tw-flex tw-gap-4 tw-pb-4">
          @if (attributes.length > 0) {
            <app-card
              label="Attributes"
              [expanded]="togglePanel.expandAll.value"
              [showExpand]="true"
              class="tw-grow"
            >
              <app-policy-attributes
                [dataSource]="attributes"
                [source]="'DS'"
              />
            </app-card>
          }
        </div>
      }
    </app-toggle-panel>
  `,
  styles: `
    .row div {
      height: 20px;
    }
  `,
})
export class DisabilityComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;

  constructor() {
    super();
  }

  disability: DisabilityDetail;
  subowner: Subowner[] = [];
  attributes: Attributes[] = [];
  restDsLaAuth = false;
  custDispAuth = false;
  subOwnerAuth = false;
  detailsAuth = false;
  claimStatusAuth = false;
  claimAttributesAuth = false;

  async ngOnInit() {
    this.restDsLaAuth = this.view.authorize('RestDsLa');
    this.custDispAuth = this.view.authorize('CustDisp');
    this.subOwnerAuth = this.session.authorize('Subowner');
    this.detailsAuth = this.session.authorize('Details');
    this.claimStatusAuth = this.session.authorize('ClaimStatus');
    this.claimAttributesAuth = this.session.authorize('ClaimAttributes');
    this.claimRow = this.view.currentClaim();
    this.disability = await this.api.disability.detailDisability(getClaimKey());
    if (this.subOwnerAuth) {
      const data = await this.api.disability.subowner(getClaimKey());
      this.subowner = data.map((item) => ({
        ...item,
        fullName: `${item.firstName || ''} ${item.lastName || ''}`.trim(),
      }));
    }
    if (this.claimAttributesAuth && this.claimRow.coverageCode !== 'AC') {
      this.attributes = await this.api.disability.attributes(
        getClaimKey(),
        Number(this.view.currentClaim().contractNumber),
      );
    }
    this.view.hideLoading();
  }
}
